module.exports = __webpack_public_path__ + "static/media/trashIconGray.639e6f27.svg";